var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-team-multi-picker"},[_c('i-multi-picker',{attrs:{"label-counter":_vm.$t('common.teamFoldersCount'),"label":_vm.resolvedLabel,"placeholder":_vm.resolvedPlaceholder,"value":_vm.value,"fetch-options":_vm.fetchSharedFolders,"option-label":"name","option-value":"id"},on:{"input":$val => _vm.$emit('input',$val)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }